module.exports = __webpack_public_path__ + "assets/wedoweb.c4e2389ad8f4f3b83e909c14261aedb9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/wedoweb.png
 ** module id = 376
 ** module chunks = 0
 **/